export const DEFAULT_AVATAR = "/img/user_avatar.jpg";
export const DEFAULT_PREPA_IMAGE = "https://squaregym.fr/app/uploads/2023/12/abdos-avec-poids-2.jpg";

export function safeDate(value) {
  if (!value) return null;

  const date = new Date(value);

  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDateFr(value) {
  const date = safeDate(value);

  if (!date) return "Date non renseignée";

  return new Intl.DateTimeFormat("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(date);
}

export function getAdherentName(adherent) {
  return (
    [adherent?.prenom, adherent?.nom].filter(Boolean).join(" ") || "Judoka"
  );
}

export function getAdherentSubtitle(adherent) {
  return adherent?.club || adherent?.genre || "Profil judoka";
}

export function getSelectedAdherent(adherents = [], selectedId) {
  return adherents.find((adherent) => adherent.id === selectedId) || null;
}

export function toBoolean(value) {
  if (value === true || value === 1) return true;

  if (value === false || value === 0 || value === null || value === undefined) {
    return false;
  }

  const normalized = String(value).trim().toLowerCase();

  return ["true", "1", "yes", "oui", "on"].includes(normalized);
}

export function getThroughData(exercise) {
  return (
    exercise?.AdherentPrepaPhysique ||
    exercise?.adherent_prepa_physique_db ||
    exercise?.through ||
    exercise?.AdherentPrepa ||
    {}
  );
}

export function normalizeAdherentExercisesFromApi(response) {
  const exercises = Array.isArray(response?.Exercices)
    ? response.Exercices
    : Array.isArray(response?.exercices)
      ? response.exercices
      : Array.isArray(response)
        ? response
        : [];

  return exercises.map((exercise) => {
    const through = getThroughData(exercise);

    return {
      ...exercise,
      date_realisation:
        exercise.date_realisation || through.date_realisation || "",
      repetitions:
        exercise.repetitions ?? through.repetitions ?? "",
      is_done: toBoolean(exercise.is_done ?? through.is_done),
    };
  });
}

export function sortAdherentExercises(exercises = []) {
  return [...exercises].sort((a, b) => {
    const doneA = toBoolean(a?.is_done);
    const doneB = toBoolean(b?.is_done);

    if (doneA !== doneB) return doneA ? 1 : -1;

    const dateA = safeDate(a?.date_realisation)?.getTime() || 0;
    const dateB = safeDate(b?.date_realisation)?.getTime() || 0;

    if (dateA !== dateB) return dateA - dateB;

    return String(a?.nom || "").localeCompare(String(b?.nom || ""), "fr");
  });
}

export function buildExerciseKey(exercise) {
  const exerciseId = exercise?.id || "exercise";
  const date = exercise?.date_realisation || "date";

  return `${exerciseId}-${date}`;
}

export function buildAdherentPrepaStats(exercises = []) {
  const done = exercises.filter((exercise) => toBoolean(exercise.is_done)).length;
  const pending = exercises.length - done;

  const nextExercise = exercises.find((exercise) => !toBoolean(exercise.is_done));

  const percent =
    exercises.length > 0 ? Math.round((done / exercises.length) * 100) : 0;

  return {
    total: exercises.length,
    done,
    pending,
    percent,
    nextExerciseName: nextExercise?.nom || "—",
    nextExerciseDate: nextExercise?.date_realisation
      ? formatDateFr(nextExercise.date_realisation)
      : "—",
  };
}